<script>
	import { currencyFormatter } from '../lib/utils';
	import { cartStore } from '../stores/cart.store';
	const data = {
		id: 1,
		imgSrc: 'images/products/p-1.jpg',
		name: 'Mountain Twin Snowboard',
		price: '8999',
		isSale: true,
		discount: 10,
	};
	const addToCart = () => {
		cartStore.update((items) => {
			const isInCart = items.find((x) => x.id === data.id);
			if (isInCart) {
				return items.map((x) =>
					x.id === data.id ? { ...x, quantity: x.quantity + 1 } : x
				);
			} else {
				return [
					...items,
					{
						...data,
						quantity: 1,
					},
				];
			}
		});
	};
	$: isInCart = $cartStore.find((x) => x.id === data.id);
</script>

<section class="section">
	<div class="flex-box">
		{#if isInCart}
			<span class="success">
				<i class="bx bx-check" />
				Added to cart {isInCart.quantity} item(s)
			</span>
		{/if}
		<div class="left">
			<div class="big-img">
				<img src={data.imgSrc} alt="" />
			</div>
		</div>
		<div class="right">
			<div class="pname">
				{data.name}
			</div>
			<p class="pdescription">
				Constantly evolved to drop ounces and amplify pop, the men's Burton
				Process Snowboard is Mark McMorris' pick for its twin freestyle
				playfulness and all-terrain prowess.
			</p>
			<div class="ratings">
				<i class="fas fa-star" />
				<i class="fas fa-star" />
				<i class="fas fa-star" />
				<i class="fas fa-star" />
				<i class="fas fa-star-half-alt" />
			</div>
			<div class="price">
				{currencyFormatter.format(data?.price)}
			</div>
			<div class="btn-box">
				<button class="btn btn-1" on:click={addToCart}>Add to Cart</button>
			</div>
		</div>
	</div>
</section>

<style>
	.success {
		color: green;
		position: absolute;
		top: 0;
		right: 0;
		font-size: 14px;
		display: flex;
		align-items: center;
		gap: 5px;
		z-index: 1;
	}
	.flex-box {
		display: flex;
		justify-content: space-between;
		gap: 80px;
		width: 1000px;
		margin: 20px auto;
		position: relative;
	}
	.left {
		width: 40%;
	}
	.big-img {
		width: 100%;
	}
	.big-img img {
		width: inherit;
	}
	.images {
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
	}
	.small-img {
		width: 100px;
		height: 150px;
		overflow: hidden;
		border-radius: 2px;
	}
	.small-img img {
		width: 100%;
		height: 100%;
		cursor: pointer;
		transition: all 0.3s ease;
	}
	.small-img:hover img {
		transform: scale(1.2);
	}
	.right {
		display: flex;
		flex-direction: column;
	}
	.pname {
		font-size: 22px;
		font-weight: 600;
		margin-top: 20px;
	}
	.pdescription {
		font-size: 16px;
		margin-top: 20px;
	}
	.ratings i {
		color: rgb(255, 136, 0);
		margin-top: 20px;
	}
	.price {
		font-size: 24px;
		font-weight: 500;
		margin: 20px 0;
		margin-left: 5px;
	}
	.price span {
		margin-right: 5px;
	}
	.size {
		display: flex;
		align-items: center;
		margin: 20px 0;
	}
	.size p {
		font-size: 18px;
	}
	.psize {
		width: 50px;
		border-radius: 10px;
		height: 30px;
		border: 1px solid #ff5e00;
		color: #000;
		text-align: center;
		margin: 0 10px;
		cursor: pointer;
		align-items: center;
		display: flex;
		justify-content: center;
	}
	.psize.active {
		border-width: 1.5px;
		background-color: #ff5e00;
		color: white;
		font-weight: 500;
	}
	.quantity {
		display: flex;
		align-items: center;
	}
	.quantity p {
		font-size: 18px;
	}
	.quantity input {
		width: 70px;
		font-size: 17px;
		font-weight: 500;
		text-align: center;
		margin-left: 15px;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 1px solid #ff5e00;
		border-radius: 10px;
		height: 30px;
	}
	.btn-box {
		display: flex;
		margin-top: 40px;
		gap: 20px;
	}
	.btn-box button {
		font-size: 18px;
		padding: 8px 25px;
		border: none;
		outline: none;
		border-radius: 6px;
		cursor: pointer;
		color: white;
	}
	.cart-btn {
		background-color: #ff5e00;
		margin-right: 20px;
	}
	.buy-btn {
		background-color: #00aeff;
	}
	.cart-btn:hover {
		background-color: #ff3c00;
	}
	.buy-btn:hover {
		background-color: #0066ff;
	}
	.product-colors span {
		width: 26px;
		height: 26px;
		top: 7px;
		margin-right: 12px;
		left: 10px;
		border-radius: 50%;
		position: relative;
		cursor: pointer;
		display: inline-block;
	}
	.black {
		background: #000;
	}
	.red {
		background: #d5212e;
	}
	.orange {
		background: #f18557;
	}
	@media only screen and (max-width: 768px) {
		.flex-box {
			flex-direction: column;
			width: 100%;
			padding: 5px;
		}
		.left {
			width: 100%;
		}
		.right {
			width: 100%;
			margin-top: 20px;
		}
		.images {
			display: none;
		}
		.big-img {
			width: 100%;
		}
		.small-img {
			width: 60px;
		}
		.pname {
			font-size: 24px;
		}
		.pdescription {
			font-size: 18px;
		}
		.price {
			font-size: 22px;
		}
		.size p {
			font-size: 16px;
		}
		.psize {
			width: 40px;
			height: 25px;
			font-size: 14px;
		}
		.quantity p {
			font-size: 16px;
		}
		.quantity input {
			width: 60px;
			font-size: 15px;
		}
		.btn-box {
			display: flex;
			gap: 10px;
			align-items: center;
			justify-content: center;
		}
		.btn-box button {
			font-size: 16px;
			padding: 8px 20px;
			margin: 10px 0;
		}
		.product-colors span {
			width: 20px;
			height: 20px;
			top: 7px;
			margin-right: 12px;
			left: 10px;
			border-radius: 50%;
			position: relative;
			cursor: pointer;
			display: inline-block;
		}
	}
</style>
